<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-center">
        <div class="text-h4 font-weight-bold mb-4">
          <v-icon large color="green">mdi-tree</v-icon>
          Producción y Venta Forestal
        </div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h7">
          Presiona el botón para agregar una siembra de arboles, cortes en tucas y ventas
        </div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/forestal" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agrega o modifica Producción y Ventas
        </v-btn>
      </v-col>

      <v-col cols="12" class="tt">
        <div class="text-h6">
          <v-icon large color="green">mdi-pine-tree</v-icon>Ver mis Producciones y
          Ventas
        </div>
        <div class="text-h8">
          Presiona la producción forestal para agregar Ventas o modificar siembra y raleos  
        </div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(forestales).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción forestal
        </div>
      </v-col>
      <!-- listado de actividades forestales en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="forestal in forestales">
            <form-card
              :key="forestal.id"
              :top-text="`Finca • ${getNombreDeFinca(forestal.id_finca)}`"
              :top-right-text="forestal.fecha"
              :bottom-right-text="producerDescription(forestal.productor)"
              :middle-text="`Ciclo ${forestal.ciclo}`"
              :sincronized="forestal.sincronizado"
              :opaque="forestal.hasOutdatedRecords"
              @click="traerRegistroYNavegar(forestal)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Cosechas',
  computed: {
    ...mapState('registros', ['forestales']),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Forestales')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getForestal', { id: registro.id })
      }
      this.$router.push(`/ru/forestal/${registro.id}`)
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
